import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/dashboard/dashboard-page';

export const Route = createFileRoute('/_app/projects/$projectId/overview')({
  component: OverviewRoute,
});

function OverviewRoute() {
  const { projectId } = Route.useParams();
  return <DashboardPage projectId={projectId} />;
}
